import React from 'react';

/**
 * stampMap（{ 'YYYY-MM-DD': stars }）から指定月の統計を計算する
 */
export function calcMonthlyStats(stampMap, year, month) {
  const prefix = `${year}-${String(month + 1).padStart(2, '0')}`; // 例: '2026-05'
  const dates = Object.keys(stampMap ?? {})
    .filter(d => d.startsWith(prefix))
    .sort();

  const totalDays = dates.length;
  if (totalDays === 0) return null;

  // 最大連続日数を計算
  let maxStreak = 1;
  let currentStreak = 1;
  for (let i = 1; i < dates.length; i++) {
    const prev = new Date(dates[i - 1]);
    const curr = new Date(dates[i]);
    const diff = (curr - prev) / (1000 * 60 * 60 * 24);
    if (diff === 1) {
      currentStreak++;
      maxStreak = Math.max(maxStreak, currentStreak);
    } else {
      currentStreak = 1;
    }
  }

  return { totalDays, maxStreak };
}

/**
 * 前月サマリーポップアップ
 * Props:
 *   year, month: 前月（0-indexed month）
 *   totalDays: 音読した日数
 *   maxStreak: 最大連続日数
 *   onClose: 閉じるコールバック
 */
export default function MonthlyRecap({ year, month, totalDays, maxStreak, onClose }) {
  const monthName = `${month + 1}月`;

  return (
    <div className="monthly-recap-overlay" onClick={onClose}>
      <div className="monthly-recap-modal" onClick={e => e.stopPropagation()}>

        {/* 花火アニメーション */}
        <div className="monthly-recap-fireworks">
          <span>🎉</span><span>⭐</span><span>🎊</span>
        </div>

        <div className="monthly-recap-month">{monthName}の　おんどく</div>
        <div className="monthly-recap-title">おつかれさまでした！</div>

        <div className="monthly-recap-stats">
          <div className="monthly-recap-stat">
            <div className="monthly-recap-stat-num">{totalDays}</div>
            <div className="monthly-recap-stat-label">📅 にち　よんだよ！</div>
          </div>
          <div className="monthly-recap-divider" />
          <div className="monthly-recap-stat">
            <div className="monthly-recap-stat-num">{maxStreak}</div>
            <div className="monthly-recap-stat-label">🔥 さいこう　れんぞく！</div>
          </div>
        </div>

        {totalDays >= 20 && (
          <div className="monthly-recap-badge">🏆 かいきん　たっせい！</div>
        )}
        {totalDays >= 10 && totalDays < 20 && (
          <div className="monthly-recap-badge">👍 よく　がんばったね！</div>
        )}

        <button className="monthly-recap-close" onClick={onClose}>
          とじる
        </button>
      </div>
    </div>
  );
}
